import axios from 'axios';
import { ClientWithAuth } from 'client/services/service';

require('dotenv').config();
const serviceUrlSuffix = '/map-configuration-service';

export default {
    getMapConfig: async (mapConfigId) => {
        mapConfigId = mapConfigId || 'default';
        const mapConfig = await (() => {
            if (!process.env.REACT_APP_MAPCONFIG_API_URL_LOCAL) {
                // Append random number to avoid mapconfig being cached
                return ClientWithAuth.get(`${serviceUrlSuffix}/mapconfig/${mapConfigId}?${Math.floor(Math.random() * 1000000)}`);
            }
            const localAxiosInstance = axios.create({
                baseURL: process.env.REACT_APP_MAPCONFIG_API_URL_LOCAL,
                timeout: 30000
            });
            return localAxiosInstance.get(`/mapconfig/${mapConfigId}`);
        })();

        return mapConfig.data;
    }
};
